import { DISCLAIMER_TEXT } from './disclaimer.js';

export function initFooter(): void {
  const root = document.getElementById('footer-root');
  if (!root) return;
  root.innerHTML = renderFooter();
}

function renderFooter(): string {
  return `
    <footer class="footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <h3>⬡ HEDGEFUN.DEV</h3>
            <p>Official website for Pochtecatl — an AI-assisted market tracking and trading automation system.</p>
            <p class="footer-disclaimer">${DISCLAIMER_TEXT}</p>
          </div>
          <div class="footer-col">
            <h4>Product</h4>
            <ul class="footer-links">
              <li><a href="#/trading-lab">Trading Lab</a></li>
              <li><a href="#/dashboard">Dashboard</a></li>
              <li><a href="#/strategies">Strategies</a></li>
              <li><a href="#/backtests">Backtests</a></li>
              <li><a href="#/risk-engine">Risk Engine</a></li>
              <li><a href="#/store">Store</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>Developer</h4>
            <ul class="footer-links">
              <li><a href="#/dev-center">Dev Center</a></li>
              <li><a href="#/docs">Documentation</a></li>
              <li><a href="#/releases">Releases</a></li>
              <li><a href="#/blog">Blog</a></li>
              <li><a href="https://github.com/xirtus" target="_blank" rel="noopener">GitHub</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>Legal</h4>
            <ul class="footer-links">
              <li><a href="#/about">About</a></li>
              <li><a href="#/contact">Contact</a></li>
            </ul>
            <div style="margin-top: 1rem; font-size: 0.72rem; color: var(--color-text-muted); font-family: var(--font-mono); line-height: 1.6;">
              Experimental software.<br/>
              Not financial advice.<br/>
              Not investment advice.<br/>
              Paper mode default.
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2026 Hedgefun.dev — Pochtecatl Project. All rights reserved.</p>
          <p style="color: var(--color-text-warning);">EXPERIMENTAL SOFTWARE — NOT FINANCIAL ADVICE</p>
        </div>
      </div>
    </footer>
  `;
}
